export const ACCOUNTING_FEATURE_ENABLED = true;

/**
 * Toggle this flag to re-enable all accounting-related functionality throughout the app.
 * When set to true, navigation items, routes and configuration options for the
 * accounting module become available again.
 */
export const ACCOUNTING_FEATURE_NAME = 'Rechnungswesen';
